import { Card, Grid2, Typography, Box, Paper } from "@mui/material";
import React from "react";
import moment from "moment";

const ClientActivity = ({ allActivity, selectedActivity, onClick }) => {
  if (!allActivity || !Array.isArray(allActivity)) {
    return null;
  }
  
  return (
    <Grid2 sx={{ position: "relative" }}>
      {allActivity.length ? (
        <>
          {allActivity.map((activity) => (
            <Card
              key={activity.id}
              elevation={2}
              sx={{
                p: 2,
                mb: 2,
                cursor: "pointer",
                backgroundColor:
                  selectedActivity?.id === activity.id
                    ? "primary.main"
                    : "background.paper",
                color:
                  selectedActivity?.id === activity.id ? "white" : "inherit",
              }}
              onClick={() => onClick(activity)}
            >
              <Box>
                <Typography
                  variant="h6"
                  color={
                    selectedActivity?.id === activity.id ? "white" : "inherit"
                  }
                >
                  {activity.name}
                </Typography>
                <Typography
                  color={
                    selectedActivity?.id === activity.id ? "white" : "inherit"
                  }
                >
                  {activity.user?.name || "Unknown"}
                </Typography>
                <Typography
                  color={
                    selectedActivity?.id === activity.id ? "white" : "inherit"
                  }
                >
                  {moment.unix(activity.date).format("MMMM Do YYYY")}
                </Typography>
              </Box>
            </Card>
          ))}
        </>
      ) : (
        <Card sx={{ p: 2, mt: 2, width: "100%" }} elevation={2}>
          <Typography variant="h6">There's no new activity.</Typography>
        </Card>
      )}
    </Grid2>
  );
};

export default ClientActivity;
